<div
   class="modal-dialog modal-dialog-centered"
   style="min-width: 750px; padding: 20px 0px 10px 0px">
   <div class="modal-content">
      <ng-container *ngIf="settingsForPractice()">
         <div class="modal-header header-border justify-content-between p-0">
            <h5 class="modal-title">Settings for {{ settingsForPractice().practiceName }}</h5>
            <button
               type="button"
               class="btn-close position-static"
               (click)="onClose()"
               aria-label="Close">
               <span aria-hidden="true">×</span>
            </button>
         </div>

         <div
            class="modal-body"
            style="padding: 10px; display: flex; flex-direction: column; width: 100%; justify-content: space-between">
            <div class="row">
               <div class="col-sm-6">
                  <div class="input-block mb-3">
                     <label
                        class="col-form-label"
                        style="font-size: 14px">
                        Deadline to Signup
                     </label>
                     <input
                        type="date"
                        class="form-control floating"
                        [ngModel]="settingsForPractice().deadlineToSignup | date : 'yyyy-MM-dd'"
                        (ngModelChange)="onDateChange.next({ newDate: $event, column: 'deadlineToSignup' })"
                        name="deadlineToSignup"
                        style="font-size: 13px" />
                  </div>
               </div>
               <div class="col-sm-6">
                  <div class="input-block mb-3">
                     <label
                        class="col-form-label"
                        style="font-size: 14px">
                        Discussion Available
                     </label>
                     <input
                        type="date"
                        class="form-control floating"
                        [ngModel]="settingsForPractice().discussionAvailable | date : 'yyyy-MM-dd'"
                        (ngModelChange)="onDateChange.next({ newDate: $event, column: 'discussionAvailable' })"
                        name="discussionAvailable"
                        style="font-size: 13px" />
                  </div>
               </div>
            </div>
            <div class="row">
               <div class="col-sm-6">
                  <div class="input-block mb-3">
                     <label
                        class="col-form-label"
                        style="font-size: 14px">
                        Discussion Complete
                     </label>
                     <input
                        type="date"
                        class="form-control floating"
                        [ngModel]="settingsForPractice().discussionComplete | date : 'yyyy-MM-dd'"
                        (ngModelChange)="onDateChange.next({ newDate: $event, column: 'discussionComplete' })"
                        name="discussionComplete"
                        style="font-size: 13px" />
                  </div>
               </div>
               <div class="col-sm-6">
                  <div class="input-block mb-3">
                     <label
                        class="col-form-label"
                        style="font-size: 14px">
                        Scheduled For PIMS Writeback
                     </label>
                     <input
                        type="date"
                        class="form-control floating"
                        [ngModel]="settingsForPractice().scheduledFor | date : 'yyyy-MM-dd'"
                        (ngModelChange)="onDateChange.next({ newDate: $event, column: 'scheduledFor' })"
                        name="scheduledFor"
                        style="font-size: 13px" />
                  </div>
               </div>
            </div>
            <div class="row">
               <div class="col-sm-6">
                  <div class="input-block mb-3">
                     <label
                        class="col-form-label"
                        style="font-size: 14px">
                        Wave Start
                     </label>
                     <input
                        type="date"
                        class="form-control floating"
                        [ngModel]="settingsForPractice().waveStart | date : 'yyyy-MM-dd'"
                        (ngModelChange)="onDateChange.next({ newDate: $event, column: 'waveStart' })"
                        name="waveStart"
                        style="font-size: 13px" />
                  </div>
               </div>
			   <div class="col-sm-6">
                  <div
                     class="input-block mb-3"
                     style="width: 100%; min-width: 100%">
                     <label
                        class="col-form-label"
                        style="font-size: 14px">
                        Practice Status
                     </label>
                     <br />
                     <p-dropdown
                        [ngModel]="settingsForPractice().batchStatus"
                        (ngModelChange)="onValueChange.next({ newValue: $event, column: 'batchStatus' })"
                        [options]="statusOptions"
                        placeholder="{{ settingsForPractice().batchStatus }}"
                        ngModelOptions="{standalone: true}"
                        name="batchStatus"
						style="width:100%"
                        [class.pricingCaptainDrop]="true"></p-dropdown>
                  </div>
               </div>
            </div>
            <div class="row">
               <div class="col-sm-6">
                  <div
                     class="input-block mb-3"
                     style="width: 100%; min-width: 100%">
                     <label
                        class="col-form-label"
                        style="font-size: 14px">
                        Pricing Captain
                     </label>
                     <br />
                     <p-dropdown
                        [ngModel]="selectedPricingPartner"
                        (ngModelChange)="handlePricingPartnerChange($event)"
                        [options]="pricingPartnerOptions"
                        optionLabel="displayName"
                        optionValue="pricingCaptainUserId"
                        placeholder="{{ settingsForPractice().pricingPartner }}"
                        ngModelOptions="{standalone: true}"
                        name="pricingPartner"
						style="width:100%"
                        [class.pricingCaptainDrop]="true"></p-dropdown>
                  </div>
               </div>
            </div>
            <div
               class="row"
               style="margin-top: 20px">
               <div class="col-sm-6"></div>
               <div
                  class="col-5"
                  style="text-align: end; padding-right: 0px; margin-left: -30px; align-content: center">
                  <a
                     href="javascript:void(0);"
                     (click)="onClose()"
                     class="v-button v-button-md v-gray">
                     Cancel
                  </a>
               </div>
               <div
                  class="col-1"
                  style="padding-left: 15px; text-align: start; margin-right: 30px; align-content: center">
                  <a
                     href="javascript:void(0);"
                     class="v-button v-button-md v-green"
                     (click)="onSave()">
                     Save
                  </a>
               </div>
            </div>
         </div>
      </ng-container>
   </div>
</div>
